import React from 'react';
import { withStyles } from 'material-ui/styles';
import UIDate from '../../core/ui/date.js';

const styles = theme => ({
  link : {
    textDecoration: 'none',
    color: 'black',
  },
  img: {
    padding: 2,
    margin: 0,
    marginRight: 8,
    border: '1px solid #aaa',
    boxSizing: 'border-box',
  },  
  header : {
    fontSize: 12, 
    color: '#404040',
    display: 'block',
  },
  date: {
    float: 'right',
  },
  title : {
    fontSize: 24,
    display: 'block',
    lineHeight: '30px',    
  },
  author: {
    fontSize: 10, 
    display: 'block',
    marginBottom: 2,
    color: '#404040',
  },
  body: {
    fontSize: 14, 
    display: 'block',
    marginBottom: 2,
    lineHeight: '20px',
    textAlign: 'justify',
  },
  keywords: {
    fontSize: 10, 
    color: '#404040',
    display: 'block',
  },
});


class Video extends React.Component {
  handleListItemClick(url) {
    if(!url) return;
    var win = window.open(url, '_blank');
    win.focus();

    const uri = '/google/q/this';
    const params = {q : '', url: url};
    this.props.server.get(uri, params, null);
    return false;
  }
  
  render() {
    const classes = this.props.classes;
    const data = this.props.data;
    const link = data.link;
    const body = 
      <div>
        <a className={'__link'} href={link}>
          <span className={classes.header}>
            <span>Video</span>
            {data.datepublished &&
              <span className={classes.date}><UIDate value={data.datepublished.value}/></span>  
            }
          </span>
        </a>      
        <a className={'__link'} href={link}> 
          {data.title &&
          <span className={'__title'}>{data.title.value}</span>
          }
        </a>
        <a className={'__link'} href={link}>
          <span className={'__url'}>
            [{data.displayLink}]
          </span>
        </a>                       
        <a className={'__link'} href={link}>
          {data.body &&
          <span className={'__snippet'}>{data.body.value}</span>
          }
        </a>        
        {data.keywords &&
          <a className={'__link'} href={link}>
            <span className={'__type'}>keywords: {data.keywords.value}</span>
          </a>         
        }
      </div>;    

    return (
      data.img ?
        <table border='0' width='100%'>
          <tbody>
            <tr>
              <td valign='top'>{body}</td>
            </tr>
            <tr>
              <td valign='top' align='center'><img className={classes.img} src={data.img.value} width={'100%'}/></td>
            </tr>
          </tbody>
        </table>
      :
        body
    );
  }

}

export default withStyles(styles)(Video);


// WEBPACK FOOTER //
// ./src/search/display/video.js